import React, { useState } from 'react';
import { Send, Smile, Paperclip } from 'lucide-react';

const ChatInput = ({ onEnviarMensagem, onDigitando, disabled = false }) => {
  const [mensagem, setMensagem] = useState('');

  const handleChange = (e) => {
    setMensagem(e.target.value);
    onDigitando(true);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (mensagem.trim()) {
      onEnviarMensagem(mensagem);
      setMensagem('');
      onDigitando(false);
    }
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      handleSubmit(e);
    }
  };

  return (
    <form
      onSubmit={handleSubmit}
      className="p-4 bg-white dark:bg-dark-card border-t border-gray-200 dark:border-dark-border"
    >
      <div className="flex items-end gap-2">
        {/* Botões de ação */}
        <div className="flex gap-1">
          <button
            type="button"
            className="p-2 text-gray-500 hover:text-gray-700 dark:text-dark-muted dark:hover:text-dark-text rounded-lg hover:bg-gray-100 dark:hover:bg-dark-bg transition-colors"
            title="Emoji"
          >
            <Smile className="w-5 h-5" />
          </button>
          <button
            type="button"
            className="p-2 text-gray-500 hover:text-gray-700 dark:text-dark-muted dark:hover:text-dark-text rounded-lg hover:bg-gray-100 dark:hover:bg-dark-bg transition-colors"
            title="Anexar arquivo"
          >
            <Paperclip className="w-5 h-5" />
          </button>
        </div>

        {/* Input de mensagem */}
        <div className="flex-1">
          <textarea
            value={mensagem}
            onChange={handleChange}
            onKeyPress={handleKeyPress}
            placeholder="Digite sua mensagem..."
            disabled={disabled}
            rows={1}
            className="w-full px-4 py-2 bg-gray-50 dark:bg-dark-bg border border-gray-200 dark:border-dark-border rounded-lg text-sm text-gray-900 dark:text-dark-text placeholder-gray-400 resize-none focus:outline-none focus:ring-2 focus:ring-primary-500 focus:border-transparent disabled:opacity-50 disabled:cursor-not-allowed"
            style={{
              minHeight: '40px',
              maxHeight: '120px',
            }}
            onInput={(e) => {
              e.target.style.height = 'auto';
              e.target.style.height = Math.min(e.target.scrollHeight, 120) + 'px';
            }}
          />
        </div>

        {/* Botão enviar */}
        <button
          type="submit"
          disabled={!mensagem.trim() || disabled}
          className="p-2 bg-primary-500 text-white rounded-lg hover:bg-primary-600 disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
          title="Enviar mensagem"
        >
          <Send className="w-5 h-5" />
        </button>
      </div>
    </form>
  );
};

export default ChatInput;
